import { IconButton, InputAdornment, TextField, useTheme } from "@material-ui/core"
import { SearchIcon, X } from "lucide-react"
import React, { useState } from "react"
import useStyles from "./SearchHeaderStyles"

export function SearchHeader({ searchParam, setSearchParam, placeholder }) {
  const classes = useStyles()
  const [isSeach, setIsSearch] = useState(false)
  const [isClosing, setIsClosing] = useState(false)
  const [isOpening, setIsOpening] = useState(false)
  const theme = useTheme()

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsSearch(false)
      setIsClosing(false)
    }, 0)
    setSearchParam("")
  }

  const handleOpening = () => {
    setIsOpening(true)
    setTimeout(() => {
      setIsSearch(true)
      setIsOpening(false)
    }, 0)
  }

  return (
    <div>
      {isSeach ? (
        <TextField
          placeholder={placeholder}
          value={searchParam}
          className={`${classes.input}`}
          variant="outlined"
          onChange={(value) => {
            setSearchParam(value.target.value)
          }}
          autoFocus
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" className={`${isClosing ? classes.fadeOut : classes.fadeIn} `}>
                <IconButton
                  onClick={() => {
                    handleClose()
                  }}
                  edge="end"
                  style={{
                    display: "flex",
                    padding: theme.espacamento.spacing100,
                    borderRadius: theme.radius.radius300,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: theme.espacamento.spacing100,
                  }}
                >
                  <X style={{ color: "gray" }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <div>
          <IconButton
            onClick={() => {
              handleOpening()
            }}
            color="inherit"
            style={{
              display: "flex",
              padding: theme.espacamento.spacing300,
              borderRadius: theme.radius.radius300,
              justifyContent: "center",
              alignItems: "center",
              gap: theme.espacamento.spacing300,
            }}
          >
            <SearchIcon style={{ color: "gray" }} />
          </IconButton>
        </div>
      )}
    </div>
  )
}
